import { SuperAdminService } from "services/superAdminService";

class BooksSAService extends SuperAdminService<any> {
  constructor() {
    super("books");
  }
}
export default new BooksSAService();
